import { render, staticRenderFns } from "./RootNavigation.vue?vue&type=template&id=1b353a5a&scoped=true&"
import script from "./RootNavigation.vue?vue&type=script&lang=js&"
export * from "./RootNavigation.vue?vue&type=script&lang=js&"
import style0 from "./RootNavigation.vue?vue&type=style&index=0&id=1b353a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b353a5a",
  null
  
)

export default component.exports